import { IValidatorFactoryService } from './validator-factory.service';
import { IRequiredMetadata } from 'app/extensibility/metadatas/validator/required-metadata';
import { IValidatorFn } from 'app/interfaces/IValidatorFn';

import { format } from 'app/shared/utils/string.util';

export class RequiredValidatorFactoryService implements IValidatorFactoryService<IRequiredMetadata> {
    // eslint-disable-next-line
    public readonly type: string = 'required';

    public createValidatorByMetadata(metadata: IRequiredMetadata): IValidatorFn {
        return this.createValidator(metadata.errorMessage);
    }
    public createValidator(errMsg?: string): IValidatorFn {
        const errorMessage = errMsg != null ? errMsg : stringResources.Required;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            return (value != null && value !== '') ? null : errorMessage;
        };
    }

    // fixed message: [entityType] name is requried.
    public createNameValidator(entityType: string): IValidatorFn {
        const errorMessage = format(stringResources.Validator_NameRequired, entityType);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            return (value != null && value !== '') ? null : errorMessage;
        };
    }
}
